import { render, staticRenderFns } from "./BrothersAndSisters.vue?vue&type=template&id=35f2f8f6&scoped=true&"
import script from "./BrothersAndSisters.vue?vue&type=script&lang=js&"
export * from "./BrothersAndSisters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2f8f6",
  null
  
)

export default component.exports